import { render, staticRenderFns } from "./term_of_use.vue?vue&type=template&id=47d5c960&"
import script from "./term_of_use.vue?vue&type=script&lang=js&"
export * from "./term_of_use.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports